/// <reference path="../../../typings/createjs/createjs.d.ts" />
interface iStartPosition{
    x: number;
    y: number;
}
export class ScrollCanvas{
    protected stage: createjs.Stage;
    protected canvas: HTMLCanvasElement;
    protected imageWidth:number;
    protected imageHegiht:number;
    protected bitmap:createjs.Bitmap;
    protected verticalMode:boolean;
    protected cb:Function;
    protected startPosition:iStartPosition;

    constructor(startPercent:number, width:number, height:number, img:string, canvasId:string, verticalMode:boolean, cb:Function){
        var canvas:HTMLCanvasElement = <HTMLCanvasElement>document.getElementById(canvasId);
        if ( canvas === null ) {
            return;
        }
        this.verticalMode = verticalMode;
        this.cb = cb;
        this.initCanvas(canvas);
        createjs.Ticker.setFPS(25);
        createjs.Ticker.on('tick', (e: createjs.TickerEvent) => { this.onEnterFrame(e) });

        this.canvas.width = width;
        this.canvas.height = height;

        var image = new Image();
        image.src = img;
        image.onload = (evt) =>{
            this.handleImageLoad(startPercent, evt);
        };

        this.addItemsToStage();
        this.stage.update();
    }

    private initCanvas(canvas:HTMLCanvasElement):void{
        this.canvas = canvas;
        this.canvas.style.background = '#F9F0E6';
        this.stage = new createjs.Stage(this.canvas);
        createjs.Touch.enable(this.stage);
        this.stage.enableMouseOver(10);
        this.stage.mouseMoveOutside = true;
    }

    private addItemsToStage():void{

    }

    private onEnterFrame(e: createjs.TickerEvent): void {
        this.stage.update(e);
    }

    private handleImageLoad(startPercent:number, event): void {
        var image = event.target;
        this.imageWidth = image.width;
        this.imageHegiht = image.height;
        this.startPosition = this.calcStartPosition(startPercent);
    	var container = new createjs.Container();
    	this.stage.addChild(container);

		this.bitmap = new createjs.Bitmap(image);
        this.bitmap.x = this.startPosition.x;
        this.bitmap.y = this.startPosition.y;
		this.bitmap.name = "image";
		this.bitmap.cursor = "pointer";

		this.bitmap.on("mousedown", (evt:any) => {
            var t = evt.target;
			t.offset = {x: t.x - evt.stageX, y: t.y - evt.stageY};
		});

		this.bitmap.on("pressmove", (evt:any) => {
            var t = evt.target;
			var newX:number = evt.stageX + t.offset.x;
			var newY:number = evt.stageY + t.offset.y;
            //belül mozoghatna ha kissebb lenne
            if ( this.verticalMode ) {
                var bottomBorder:number = this.canvas.height - this.imageHegiht;
                if ( newY >= 0 && newY <= bottomBorder ) {
                    t.y = newY;
                }
                this.claclPercent(newY);
            }else{
                if ( newX >= 0 && (newX + this.imageWidth) <= this.canvas.width ) {
                    t.x = newX;
                }
                this.claclPercent(newX);
            }

		});

		// bitmap.on("rollover", function (evt) {
		// });
        //
		// bitmap.on("rollout", function (evt) {
		// });
        container.addChild(this.bitmap);
    }

    protected claclPercent(position:number):void{
        var percent:number = 0;
        if ( this.verticalMode ) {
            percent = position / this.canvas.height * 100;
        }else{
            percent = position / this.canvas.width * 100;
        }
        this.cb(percent);
    }



    protected calcStartPosition(startPercent:number):iStartPosition{
        var ret:iStartPosition = {
            x: 0,
            // y: 0
            y: 3 // FIXME: just this site
        }
        if ( this.verticalMode ) {
            ret.y = this.canvas.height *  (startPercent / 100);
        }else{
            ret.x = this.canvas.width * (startPercent / 100);
            var maxXPositon:number = this.canvas.width - this.imageWidth;
            if ( ret.x > maxXPositon ) {
                ret.x = maxXPositon;
            }
        }
        return ret;
    }
}



// WEBPACK FOOTER //
// ./lib/components/ScrollCanvas.ts